export const ARTICLE_UNIT_PIECE = 'piece'
export const ARTICLE_UNIT_HOUR = 'hour'
export const ARTICLE_UNIT_MILE = 'mile'
